import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import GIF from "../../images/services-usa/saas-video/happy.gif";
import { Link } from "gatsby";

function Productset() {
  return (
    <section className="product_set p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <span className="pro_span_head">
              Entrusted with producing stellar SaaS videos for{" "}
              <strong>100+</strong> Tech Companies
            </span>
            <h2>
              SaaS Video Production Sets Your{" "}
              <span>Product Up for Success</span>
            </h2>
            <p>
              As per Forbes, 90% customers are likely to buy more easily after
              watching a video. SaaS products are complex, and software
              explainer videos make it easier for you to communicate value, and
              illicit a warm response from your prospect. Therefore, by
              investing in SaaS video production you can make a difference.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Connect
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-0"
          >
            <img src={GIF} alt="TekRevol" />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Productset;
